import { BaseUnit } from '../../../theming/baseUnitDefinition';

export const componentConfigurationKey = 'bottomPageRecommendations';

export interface BottomPageRecommendationsThemeProps {
  baseUnit: BaseUnit;
  placeholderBackgroundColor: string;
  titleColor: string;
}
